import {
  IMdfActivityWithBusinessPriorities,
  IMdfBreakdownGroup,
  TMdfBreakdownGroupField,
} from '../model/types'

import { getMdfActivityContributions } from './getMdfActivityContributions'

/**
 * Buckets the filtered MDF activities by the selected group field and sums the requested and
 * paid amounts per bucket. Feeds the "Requested vs Paid" stacked bar chart. Buckets are sorted
 * by requested amount descending to match the visual ordering of the chart.
 *
 * Which bucket(s) an activity lands in, and with how much money, is
 * {@link getMdfActivityContributions} — this only adds the per-bucket sums on top.
 */
export const getMdfBreakdownGroups = (
  activities: IMdfActivityWithBusinessPriorities[],
  groupField: TMdfBreakdownGroupField,
  isUsd: boolean
): IMdfBreakdownGroup[] => {
  const totals = new Map<string, IMdfBreakdownGroup>()

  activities.forEach((activity) => {
    getMdfActivityContributions(activity, groupField, isUsd).forEach(
      ({ name, requested, paid }) => {
        const group = totals.get(name) ?? { name, requested: 0, paid: 0 }

        totals.set(name, {
          name,
          requested: group.requested + requested,
          paid: group.paid + paid,
        })
      }
    )
  })

  return Array.from(totals.values()).sort((left, right) => right.requested - left.requested)
}
